import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {ExchangeDetail} from "../../../model/exchange/exchange-detail";
import {ExchangeExchangeDetailService} from "../../../services/exchange/exchange-exchange-detail.service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-exchange-detail',
  templateUrl: './exchange-detail.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class ExchangeDetailComponent extends CrudBaseComponent<ExchangeDetail> {

  //fields
  clearingHouses: FieldRecord<any>[]
  countries: FieldRecord<any>[]
  timeZones: FieldRecord<any>[]

  constructor(cdref: ChangeDetectorRef,
              exchangeExchangeDetailService: ExchangeExchangeDetailService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = exchangeExchangeDetailService;
    this.newRecord = new ExchangeDetail();
    let date: Date = new Date();
    date.setHours(23);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setUTCMilliseconds(0);
    this.newRecord.closingHourDate = date;
    date = new Date();
    date.setHours(2);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setUTCMilliseconds(0);
    this.newRecord.openingHourDate = date;
  }

  prepareRecordForCreate() {
  }

  prepareRecordForEdit() {
    if (this.formRecord) {
      if (this.formRecord.closingHour||this.formRecord.closingHour==0) {
        let date: Date = new Date();
        if (this.formRecord.closingHour == 0) {
          date.setHours(0);
          date.setMinutes(0);
        } else {
          let hourSt: string = this.formRecord.closingHour.toString();
          date.setHours(Number.parseInt(hourSt.substring(0, hourSt.length - 2)));
          date.setMinutes(Number.parseInt(hourSt.substring(hourSt.length - 2, hourSt.length)));
        }
        date.setSeconds(0);
        date.setUTCMilliseconds(0);
        this.formRecord.closingHourDate = date;
      }
      if (this.formRecord.openingHour||this.formRecord.openingHour==0) {
        let date: Date = new Date();
        if (this.formRecord.openingHour == 0) {
          date.setHours(0);
          date.setMinutes(0);
        } else {
          let hourSt: string = this.formRecord.openingHour.toString();
          date.setHours(Number.parseInt(hourSt.substring(0, hourSt.length - 2)));
          date.setMinutes(Number.parseInt(hourSt.substring(hourSt.length - 2, hourSt.length)));
        }
        date.setSeconds(0);
        date.setUTCMilliseconds(0);
        this.formRecord.openingHourDate = date;
      }
    }
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'clearingHouse',
      },
      {
        field: 'state',
        notFilterable: true,
        mapId: record => (record.state === 'CONNECTED' ?  '<i title="Connected" class="fa-solid fa-right-to-bracket fa-fade cc-green"></i>'
          :'<i title="Disconnected" class="fa-solid fa-right-from-bracket status-disconnected"></i>')
        // style: record => 'color:' + (record.state === 'CONNECTED' ? 'green;' : (record.state === 'DISCONNECTED' ? 'orange;' : 'tomato;'))
        // icon: (value: ExchangeDetail) => value.timeZone ? 'flag-icon flag-icon-' + value.timeZone.toLowerCase() : '',
        // mapId: value => ''
      },
      {
        field: 'code',
      },
      {
        field: 'description',
        // icon: (value: ExchangeDetail) => value.timeZone ? 'flag-icon flag-icon-' + value.timeZone.toLowerCase() : '',
        // mapId: value => ''
      },
      {
        field: 'country',
        icon: (value: ExchangeDetail) => value.country ? 'flag-icon flag-icon-' + value.country.toLowerCase() : '',
        mapId: value => ''
      },
      {
        field: 'timeZone',
        // icon: (value: ExchangeDetail) => value.timeZone ? 'flag-icon flag-icon-' + value.timeZone.toLowerCase() : '',
        // mapId: value => ''
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'clearingHouse',
            required: true,
            filter: true,
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.clearingHouses,
          },
          {
            field: 'code',
            required: true,
            filter: true,
            column: 3,
            type: TYPE.TEXT
          },
          {
            field: 'country',
            filter: true,
            column: 3,
            type: TYPE.DROPDOWN,
            icon: id => id ? ('flag-icon flag-icon-' + id.toLowerCase()) : '',
            options: () => this.countries,
            changed: event => this.formRecord.country = event.value.toUpperCase()
          },
          {
            field: 'timeZone',
            filter: true,
            column: 3,
            type: TYPE.DROPDOWN,
            icon: id => id ? ('flag-icon flag-icon-' + id.toLowerCase()) : '',
            options: () => this.timeZones,
            changed: event => {
              this.formRecord.timeZone = event.value.toUpperCase();
            }
          },
          {
            field: 'description',
            filter: true,
            column: 6,
            type: TYPE.TEXT
          },
          {
            field: 'openingHourDate',
            column: 3,
            type: TYPE.TIME,
            changed: (event, record) => {
              if (record.openingHourDate)
                record.openingHour = Number.parseInt(record.openingHourDate.getHours() +
                  (record.openingHourDate.getMinutes().toString().length == 1 ? '0' : '')
                  + record.openingHourDate.getMinutes());
              else
                record.openingHour = 0;
            }
          },
          {
            field: 'closingHourDate',
            column: 3,
            type: TYPE.TIME,
            changed: (event, record) => {
              if (record.closingHourDate)
                record.closingHour = Number.parseInt(record.closingHourDate.getHours() +
                  (record.closingHourDate.getMinutes().toString().length == 1 ? '0' : '')
                  + record.closingHourDate.getMinutes() + '');
              else
                record.closingHour = 0;
            }
          },
          {
            field: 'apsGroupIdRegex',
            column: 3,
            type: TYPE.TEXT,
          },
          {
            field: 'apsExcludeTradeType',
            column: 3,
            type: TYPE.TEXT
          },
          {
            field: 'updatePriceAllowedTradeTypes',
            column: 3,
            type: TYPE.TEXT
          },
          {
            field: 'micCode',
            column: 4,
            type: TYPE.TEXT
          },
          {
            field: 'state',
            column: 2,
            type: TYPE.NONE,
            disabled: record => true,
            hidden: record => !record.state,
            icon: record => '',
            iconValue: (event, record) => record.state,
            style: record => 'color:' + (record.state === 'CONNECTED' ? 'green' : (record.state === 'DISCONNECTED' ? 'orange' : 'tomato'))+' !important'
          },
          {
            column: 2,
            type: TYPE.NONE,
            hidden: record => record.state
          },
          {
            field: 'enabled',
            column: 2,
            type: TYPE.CHECKBOX
          },
          {
            field: 'readonly',
            column: 2,
            type: TYPE.CHECKBOX
          },
          {
            field: 'openCloseManagement',
            column: 2,
            type: TYPE.CHECKBOX
          },
          {
            field: 'giveinRejection',
            column: 2,
            type: TYPE.CHECKBOX
          },
          {
            field: 'reversalManagement',
            column: 2,
            type: TYPE.CHECKBOX
          },
          {
            field: 'generateTrade',
            column: 3,
            type: TYPE.CHECKBOX
          },
          {
            field: 'generateOrder',
            column: 3,
            type: TYPE.CHECKBOX
          },
          {
            field: 'giveupCommissionAcceptMng',
            column: 3,
            type: TYPE.CHECKBOX
          },
          {
            field: 'changeReferenceCauseClearing',
            column: 3,
            type: TYPE.CHECKBOX
          },
          {
            field: 'virtual',
            column: 3,
            type: TYPE.CHECKBOX
          },
          {
            field: 'apscustomoverride',
            column: 3,
            type: TYPE.CHECKBOX
          },
          {
            field: 'taspriceoverride',
            column: 3,
            type: TYPE.CHECKBOX
          },
          {
            field: 'traderMemoManagement',
            column: 3,
            type: TYPE.CHECKBOX
          },
          {
            field: 'giveupAccountTypeManagement',
            column: 3,
            type: TYPE.CHECKBOX
          },
          {
            field: 'giveupMessage2Management',
            column: 3,
            type: TYPE.CHECKBOX
          },
          {
            field: 'contractVersion',
            column: 3,
            type: TYPE.CHECKBOX
          },
          {
            field: 'apsManagement',
            column: 3,
            type: TYPE.CHECKBOX
          },
          {
            field: 'apsManageByUser',
            column: 3,
            type: TYPE.CHECKBOX
          }]
      }];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;
    this.commonFieldService.getClearingHouses(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.clearingHouses = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 3;
    })
    this.commonFieldService.getCountries(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.countries = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 3;
    })
    this.commonFieldService.getTimeZones(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.timeZones = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 3;
    })
  }

  onFormShow() {
  }
}
